import PipFarm from "@modules/LandingPagePipFarm";

const LandingPagePipFarm = () => {
  return <PipFarm />;
};
export default LandingPagePipFarm;
